import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import Common from 'src/app/common/common';
import { LoaderService } from 'src/app/services/loader.service';
import { RegisterService } from 'src/app/services/register.service';

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
  ],
  templateUrl: './header.component.html',
  styles: [`
    .header-logo {
      width: 400px;
      max-width: 100%;
      height: auto;
    }

    @media (max-width: 900px) {
      .header-logo {
        width: 220px;
      }
    }

    @media (max-width: 600px) {
      .header-logo {
        width: 160px;
      }
       b.fs-6 {
    display: none;
  }
    }
  `],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();

  sessionGet: any = Common.userLogin()

  userRole: any

  constructor(private router: Router, private loaderService: LoaderService , private registetService : RegisterService) {

    this.loaderService.HeaderUpdate.subscribe((message) => {
      this.sessionGet = Common.userLogin()

      this.registetService.getUserSelf().subscribe({
        next:(res:any)=>{
          this.userRole = res.centername
          console.log("user role in header ", this.userRole);
        }
      })
      

    });



  }

  logout() {
    // Clear user data from session storage
    sessionStorage.removeItem('user');
    // Optionally, you can redirect to the login page or home page after logout
    // For example, redirect to the login page
    this.router.navigate(['/authentication/login']);
  }

  findUserRole(user:string){  
  return  Common.roleList().filter((item:any) => item.value == user)?.[0]?.text;
  }
}